import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    OrderDetailContainer,
    OrderDetailBody,
    OrderDetailsTabs,
    OrderDetailTabBodyContainer,
    OrderDetailTabBody,
    WrapperContiner,
} from './OrderDetails.styled';
import { OrderSummaryTabs } from 'src/constants/orderListConstants.js';
import OrderSummary from './orderSummary/OrderSummary';
import OrderDetailTab from './orderDetailTab/OrderDetailTab';
import PriceOverride from './priceOverride';
import SetAvailabilityPending from './setAvailabilityPending/SetAvailabilityPending';
import ProcedureData from './procedureData/ProcedureData';

import ShipAndTrack from './shipAndTrack/ShipAndTrack';
import ReplenRequest from './replenRequest/ReplenRequest';
import BackOrderDetails from './backOrderDetails/BackOrderDetails';

import OrderDetailTabListContainer from './orderDetailTabList/OrderDetailTabList';

import OrderDetailHeader from './orderDetailHeader/OrderDetailHeader';
/* More Actions */
import OrderDetailFooter from './orderDetailFooter/OrderDetailFooter';
import SendUsageReport from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport';
import ViewReport from 'src/pages/orders/components/reportsAndInvoice/viewReport/ViewReport';
import BillingSummary from './billingSummary/BillingSummary';
import {
    showHideSummaryModal,
    showHideSaveAsTemplateAction,
    setOrderSummaryTabAction,
    showHideRequestInvoice,
    showHideViewReportAction,
    showHideSendReportAction,
    resetViewPdfReport,
    setSendReportModalState,
    setDescrepencyImageViewState,
    setImplantableAndInstrumentProducts,
} from 'src/pages/orders/redux/actions';
import CreateTemplate from 'src/common/refactoredComponents/createTemplate';
import RequestInvoice from 'src/pages/orders/components/reportsAndInvoice/requestInvoice/RequestInvoice';
import SetItemModal from 'src/common/components/setItemModal';
import NoUsageToReportContainer from 'src/pages/reportUsage/noUsageToReport';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';

import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';
import {
    addScrollTopHandler,
    checkTemplateReviewUserRoleChanges,
    getUserDetails,
    removeScrollTopHandler,
    setMyCaseRef,
    logErrorToConsole,
} from 'src/utils/util';
import CreateEquityTemplate from 'src/pages/equity/components/common/createTemplate/index.jsx';
import PoImagePreview from 'src/pages/reportUsage/record/components/reportPayment/AddPo/PoImagePreview';
import { resetPoImagePreview } from 'src/pages/reportUsage/redux/action/actionCreators';
import { SURGERY_TEMPLATE_MANDATORY_FIELDS } from 'src/constants/appConstants';
import { isMobileView } from 'src/utils/util';
import { setIsMastOrder } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { CTA_IDS } from 'src/constants/appConstants';

const OrderDetails = ({
    showOrderListDetails,
    orderListDetailsClose,
    fromCalendar,
    fromListScreen,
    isOrderHistory,
    setCurrentActivity,
    retriggerEventNotification,
    setRetriggerEventNotification,
    setNotificationDetails,
    isFromPhysicianDetails
}) => {
    const { t } = useTranslation();
    const [orderDetailsTabs, setOrderDetailTabs] = useState([]);
    const [orderTabActiveId, setOrderTabActiveId] = useState(null);
    const {
        sendReportModal,
        requestInvoiceState,
        isRequestInvoiceOrderListPage,
        isRequestInvoiceSearchListPage,
        orderBasicDetails,
        billingSummary,
        descrepencyImageView,
    } = useSelector((state) => state.orderSummaryReducer);
    const {
        myCaseRef,
        showSaveAsTemplate,
        orderSummaryModal,
        selectedTabId,
        tabLists,
        callToActionList,
    } = useSelector((state) => state.orderSummaryReducer);
    const salesOrgs = useSelector(
        (state) => state.loginReducer.allSalesOrg
    );
    const isMastOrder = useSelector((state) => state.loginReducer.isMastOrder);

    const employeeRole = getUserDetails();
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const isCallToActionEmpty = callToActionList.filter(item=>item.ctaId!==CTA_IDS.viewOrder).length === 0;//filtering out view order CTA

    // if (
    //     orderBasicDetails.currentOrderType === 'KE' ||
    //     orderBasicDetails.currentOrderType === 'ZKA'
    // ) {
    //     for (let i = 0; i < tabLists.length; i++) {
    //         if (tabLists[i] === 'orderBasicDetails') {
    //             //tabLists.splice(i, 1);
    //         }
    //     }
    // }

    if (
        !tabLists.includes('procedureData') &&
        orderBasicDetails?.currentOrderType == 'ZOR'
    ) {
        //static Procedure Data
        callToActionList.map((list) => {
            if (list?.ctaId === 'CTA_022') {
                tabLists.push('procedureData');
            }
        });
    }

    if (
        JSON.stringify(billingSummary.cartSummary) === '{}' &&
        orderBasicDetails?.currentOrderType == 'ZOR'
    ) {
        for (let i = 0; i < tabLists.length; i++) {
            if (tabLists[i] === 'billingSummary') {
                tabLists.splice(i, 1);
            }
        }
    }
    const showReferenceFooter = useSelector(
        (state) => state.surgeryDetailsReducer.showFooterTransferSurgery
    );
    const { orderList } = useSelector((state) => state.ordersListReducer);
    const { searchResultOrderList } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );
    const showUnidPostponePopup = useSelector(
        (state) => state.noUsageToReportReducer.showUnidPostponePopup
    );
    const [myCaseRefId, setMycaseRefId] = useState('');
    const [setDetails, showSetDetails] = useState(false);
    const [itemDetails, showItemDetails] = useState(false);
    const [selectedItem, setSelectedItem] = useState('');
    const [previousSelectedItem, setPreviousItem] = useState('');
    const [productStack, setProductStack] = useState([]);
    const [dialogZindex, setDialogZindex] = useState(10000);
    const dispatch = useDispatch();

    const { viewReportOpen } = useSelector((state) => state.viewReportReducer);

    let order = orderList?.find((order) => {
        return order.myCaseRef === myCaseRef;
    });

    if (!order) {
        order = searchResultOrderList?.find((order) => {
            return order.myCaseRef === myCaseRef;
        });
    }

    useEffectWithErrorLogging(() => {
        if (orderSummaryModal) {
            addScrollTopHandler();
        }
        return () => {
            removeScrollTopHandler();
            window.onscroll = null;
        };
    }, [orderSummaryModal]);
    // No Usage To Report
    const showCancelSurgeryPopup = useSelector(
        (state) => state.noUsageToReportReducer.showCancelSurgeryPopup
    );
    const products = useSelector(
        (state) => state.orderSummaryReducer.orderDetails
    );
    const showCaseCancelOrPostpone = useSelector(
        (state) => state.noUsageToReportReducer.showCaseCancelOrPostpone
    );
    const showNoUsageToReportPopup = useSelector(
        (state) => state.noUsageToReportReducer.showNoUsageToReportPopup
    );
    const viewProcedureScreen = useSelector(
        (state) => state.noUsageToReportReducer.viewProcedureScreen
    );
    const cancelSurgeryData = useSelector(
        (state) => state.noUsageToReportReducer.cancelSurgeryData
    );
    const isCancelWithoutReason = useSelector(
        (state) => state.noUsageToReportReducer.isCancelWithoutReason
    );
    const cancelUsageInProgress = useSelector(
        (state) => state.noUsageToReportReducer.cancelUsageInProgress
    );

    useEffectWithErrorLogging(() => {
        if (fromCalendar === false && fromListScreen === false) {
            selectedMycaseRefId(myCaseRef);
        }
    }, [handleSetItemClick]);

    useEffectWithErrorLogging(() => {
        setMyCaseRef(myCaseRef);
        dispatch(setIsMastOrder(orderBasicDetails?.isMastOrder || isMastOrder));
        return ()=>{
            setMyCaseRef('');
        };
        // return () => {
        //     dispatch(setIsMastOrder(false));
        // };
    }, [orderBasicDetails]);

    const onTabSwitchHandler = (Id) => {
        setOrderTabActiveId(Id);
        dispatch(setOrderSummaryTabAction({ selectedTabId: Id }));
    };

    useEffectWithErrorLogging(() => {
        let implantList = [];
        let instrumentList = [];
        products?.map((i) => {
            if (i.isSet) {
                i?.productMoreDetails?.billOfMaterials?.map((d) => {
                    if (d.isImplantable) {
                        implantList.push(d);
                    } else if (d.isInstrument) {
                        instrumentList.push(d);
                    }
                });
            } else {
                if (i.implantable) {
                    implantList.push(i);
                } else if (i.instrument) {
                    instrumentList.push(i);
                }
            }
        });
        implantList = implantList?.map((i) => {
            return {
                cfn: i.bom ? i.bom : i.productCFN || i.cfn,
                ...i,
            };
        });
        instrumentList = instrumentList?.map((i) => {
            return {
                cfn: i.bom ? i.bom : i.productCFN || i.cfn,
                ...i,
            };
        });
        implantList = Object.values(
            implantList?.reduce((acc, curr) => {
                if (!acc[curr.cfn]) {
                    acc[curr.cfn] = { ...curr };
                } else {
                    acc[curr.cfn].quantity += curr.quantity;
                }
                return acc;
            }, {})
        );
        instrumentList = Object.values(
            instrumentList?.reduce((acc, curr) => {
                if (!acc[curr.cfn]) {
                    acc[curr.cfn] = { ...curr };
                } else {
                    acc[curr.cfn].quantity += curr.quantity;
                }
                return acc;
            }, {})
        );
        dispatch(
            setImplantableAndInstrumentProducts({
                implantProducts: implantList?.sort((a, b) =>
                    a.cfn?.localeCompare(b.cfn)
                ),
                instrumentProducts: instrumentList?.sort((a, b) =>
                    a.cfn?.localeCompare(b.cfn)
                ),
            })
        );
    }, [tabLists]);
    useEffectWithErrorLogging(() => {
        const tabListsDetails = OrderSummaryTabs()?.filter(
            (x) => tabLists?.findIndex((tabList) => tabList === x.id) != -1
        );

        if (
            orderBasicDetails?.currentOrderType === 'KE' ||
            orderBasicDetails?.currentOrderType === 'ZKA'
        ) {
            const basicDetailsTabId = tabListsDetails.findIndex(
                (x) => x.id === OrderSummaryTabs()[0].id
            );

            if (basicDetailsTabId >= 0) {
                tabListsDetails.splice(basicDetailsTabId, 1);
            }
            if (
                !tabListsDetails.some((x) => x.id === OrderSummaryTabs()[1].id)
            ) {
                if (isOrderHistory) {
                    tabListsDetails.unshift(OrderSummaryTabs()[1]);
                } else {
                    tabListsDetails.push(OrderSummaryTabs()[1]);
                }
            }
        }

        if (tabListsDetails?.length > 0) {
            setOrderDetailTabs(tabListsDetails);
            // if (
            //     selectedTabId === 'orderBasicDetails' &&
            //     (orderBasicDetails.currentOrderType === 'KE' ||
            //         orderBasicDetails.currentOrderType === 'ZKA')
            // ) {
            //     setOrderTabActiveId('orderDetails');
            // } else {

            // }
            setOrderTabActiveId(selectedTabId);
        } else {
            setOrderDetailTabs([]);
        }
    }, [tabLists]);

    const toggleViewTemplate = () => {
        dispatch(
            showHideSaveAsTemplateAction({
                showSaveAsTemplate: !showSaveAsTemplate,
            })
        );
        dispatch(
            showHideSummaryModal({
                orderSummaryModal: !orderSummaryModal,
            })
        );
    };
    const onCloseRequestInvoiceHandler = () => {
        dispatch(
            showHideRequestInvoice({
                requestInvoiceState: false,
                myCaseRefId: myCaseRef,
                isRequestInvoiceOrderListPage: false,
                isRequestInvoiceSearchListPage: false,
            })
        );
        dispatch(
            showHideSummaryModal({
                orderSummaryModal: true,
            })
        );
    };
    const getTabActivity = (activity) => {
        let tabComponent = null;
        switch (activity) {
            case 'orderBasicDetails':
                tabComponent = <OrderSummary />;
                break;
            case 'orderDetails':
                tabComponent = (
                    <OrderDetailTab
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            case 'billingSummary':
                tabComponent = (
                    <BillingSummary
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            case 'backOrders':
                tabComponent = (
                    <BackOrderDetails
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            case 'shipAndTrack':
                tabComponent = (
                    <ShipAndTrack
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            case 'replenishmentRequests':
                tabComponent = (
                    <ReplenRequest
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            case 'priceOverride':
                tabComponent = (
                    <PriceOverride
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            case 'setAvailabilityPending':
                tabComponent = (
                    <SetAvailabilityPending
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            case 'procedureData':
                tabComponent = (
                    <ProcedureData
                        handleSetItemClick={handleSetItemClick}
                        ordersList={order}
                    />
                );
                break;
            default:
                tabComponent = null;
                break;
        }
        return tabComponent;
    };

    const cfnSplitHandler = (cfn) => {
        const cfnNumber = cfn?.split('.');
        return cfnNumber?.length && cfnNumber.length > 0 ? cfnNumber[0] : cfn;
    };

    const handleSetItemClick = (items, isBack) => {
        const { isSet, cfn, productCFN, bom, salesOrg, status } = items;
        const item = {
            ...items,
            cfn: productCFN || cfn || bom,
        };
        let cfnId = cfnSplitHandler(cfn || bom || productCFN);

        if (isSet) {
            showSetDetails(true);
            setSelectedItem({
                ...item,
                salesOrg: salesOrg
                    ? salesOrg
                    : salesOrgs?.length > 0
                    ? salesOrgs[0]
                    : 'S002',
                cfn: cfnId,
            });
            showItemDetails(false);
            setPreviousItem({
                ...item,
                cfn: cfnId,
            });
        } else {
            showSetDetails(false);
            showItemDetails(true);
            setSelectedItem({
                ...item,
                salesOrg: salesOrg
                    ? salesOrg
                    : salesOrgs?.length > 0
                    ? salesOrgs[0]
                    : 'S002',
                cfn: cfnId,
            });
        }
        dispatch(
            showHideSummaryModal({
                orderSummaryModal: false,
            })
        );
        handleProductStack(item, isBack === true ? false : true);
        selectedMycaseRefId(myCaseRef);
    };
    const handleProductStack = (item, isAdd) => {
        if (isAdd) {
            setProductStack([...productStack, item]);
        } else {
            let list = productStack.slice(0, -1);
            setProductStack(list);
        }
    };

    const selectedMycaseRefId = (myCaseref) => {
        setMycaseRefId(myCaseref);
    };

    const onCloseViewReportHandler = () => {
        dispatch(showHideSendReportAction({ sendReportModal: true }));
        dispatch(
            showHideViewReportAction({
                viewReportOpen: false,
                viewReportBackNavigate: '',
            })
        );
        dispatch(resetViewPdfReport());
    };

    const onCloseViewReportIconHandler = () => {
        dispatch(
            showHideViewReportAction({
                viewReportOpen: false,
                viewReportBackNavigate: '',
            })
        );
        dispatch(
            setSendReportModalState({
                showModal: false,
                myCaseRefId: '',
                isUsageReportOrderListPage: false,
                isUsageReportSearchListPage: false,
            })
        );
        dispatch(resetViewPdfReport());
    };
    return (
        <>
            {showOrderListDetails && !viewProcedureScreen ? (
                <ModalDialog
                    modalHeight={'calc(100vh - 110px)'}
                    modalWidth={'70%'}
                    smalModalWidth={'85%'}
                    mbPaddingBottom={'0px'}
                    left={'7%'}
                    right={'7%'}
                    top={'7%'}
                    bottom={'10%'}
                    padding={'0px'}
                    handleClose={orderListDetailsClose}
                    isIPadPotrait={false}
                    zIndex={'2000'}
                    marginTop={
                        isCondensedView && isMobileView() ? '0rem' : '7.5rem'
                    }
                    borderTopLeftRadius={
                        isCondensedView && isMobileView() && '0px'
                    }
                    borderTopRightRadius={
                        isCondensedView && isMobileView() && '0px'
                    }
                >
                    <WrapperContiner
                        isIPadPotrait={true}
                        iPadPortraitBackgroundColor={
                            'linear-gradient(to bottom, #140f4a 20px, whitesmoke 5%)'
                        }
                    >
                        <OrderDetailContainer
                            iPadPortraitBorderTopRightRadius={'0px'}
                            iPadPortraitBorderTopLeftRadius={'0px'}
                            isIPadPotrait={true}
                            isConsignment={
                                orderBasicDetails?.currentOrderType == 'KE' ||
                                orderBasicDetails?.currentOrderType === 'ZKA'
                            }
                            isCondensedViewHeight={
                                (isCondensedView &&
                                    orderBasicDetails?.currentOrderType ===
                                        'ZLC') ||
                                (isCondensedView &&
                                    orderBasicDetails?.currentOrderType ===
                                        'KB') ||
                                (isCondensedView &&
                                    orderBasicDetails?.currentOrderType ===
                                        'ZLB')
                            }
                            isConsignmentReturn={
                                orderBasicDetails?.currentOrderType === 'ZKA'
                            }
                            isCondensedView={isCondensedView}
                            isCallToActionEmpty={isCallToActionEmpty}
                        >
                            <OrderDetailBody
                                padding={isCondensedView && '1rem 0 0 0'}
                            >
                                <OrderDetailHeader
                                    orderListDetailsClose={
                                        orderListDetailsClose
                                    }
                                    fromCalendar={fromCalendar}
                                    fromListScreen={fromListScreen}
                                    isCondensedView={isCondensedView}
                                />
                                <OrderDetailsTabs
                                    padding={isCondensedView && '0 1rem 0 1rem'}
                                >
                                    <OrderDetailTabListContainer
                                        orderDetailTabList={orderDetailsTabs}
                                        tabActiveId={orderTabActiveId}
                                        tabSwitch={onTabSwitchHandler}
                                        isCondensedView={isCondensedView}
                                    />
                                </OrderDetailsTabs>
                                <OrderDetailTabBodyContainer
                                    scrollBarWidth={'5px'}
                                    scrollBarBackgroundColor={'#888'}
                                    scrollBarBorderRadius={'10px'}
                                    scrollbarHeight={'12rem'}
                                    scrollBarBackGroundColorOnHover={'#555'}
                                    mobileDeviceScrollBarDisplay={'block'}
                                    isCallToActionEmpty={isCallToActionEmpty}
                                    isCondensedView={isCondensedView}
                                    isOrderHistory={isOrderHistory}
                                >
                                    <OrderDetailTabBody
                                        width={
                                            orderTabActiveId === 'backOrders' &&
                                            '100%'
                                        }
                                        mobileWidth={isCondensedView && '100%'}
                                    >
                                        {getTabActivity(orderTabActiveId)}
                                    </OrderDetailTabBody>
                                </OrderDetailTabBodyContainer>
                            </OrderDetailBody>
                        </OrderDetailContainer>
                    </WrapperContiner>
                    {/* {isMobile ? (
                        <EmptyBox mobileMargin="0 0 35% 0"></EmptyBox>
                    ) : null} */}

                    {window.innerWidth <= sizes.mobileDevice &&
                        isCancelWithoutReason &&
                        cancelUsageInProgress && (
                            <Backdrop
                                showCloseButton={false}
                                showBackdrop={true}
                                isModal
                                loaderBackground
                            >
                                <Spinner
                                    id="orders-orderDetails-orderDetails-loadingSpinner"
                                    animation="border"
                                    variant="primary"
                                    small
                                ></Spinner>
                            </Backdrop>
                        )}
                    {!showReferenceFooter &&
                        orderBasicDetails?.currentOrderType != 'ZKA' && !isCallToActionEmpty && (
                            <OrderDetailFooter
                                fromCalendar={fromCalendar}
                                fromListScreen={fromListScreen}
                                isOrderHistory={isOrderHistory}
                                toggleViewTemplate={toggleViewTemplate}
                                setCurrentActivity={setCurrentActivity}
                                // moreFunctionality={(name) =>
                                //     onMoreActionFunctionalityHandler(name)
                                // }
                                  retriggerEventNotification={retriggerEventNotification}
                                        setRetriggerEventNotification={setRetriggerEventNotification}
                                        setNotificationDetails={setNotificationDetails}
                                isFromPhysicianDetails={isFromPhysicianDetails}
                            />
                        )}
                </ModalDialog>
            ) : null}
            {showOrderListDetails &&
                cancelSurgeryData &&
                Object.keys(cancelSurgeryData).length > 0 &&
                (showNoUsageToReportPopup ||
                    showCancelSurgeryPopup ||
                    viewProcedureScreen ||
                    showUnidPostponePopup ||
                    showCaseCancelOrPostpone) && (
                    <NoUsageToReportContainer
                        cancelSurgeryData={cancelSurgeryData}
                        showNoUsageToReportPopup={showNoUsageToReportPopup}
                        showCancelSurgeryPopup={showCancelSurgeryPopup}
                        viewProcedureScreen={viewProcedureScreen}
                        showUnidPostponePopup={showUnidPostponePopup}
                        showCaseCancelOrPostpone={showCaseCancelOrPostpone}
                    />
                )}
            {sendReportModal ? <SendUsageReport /> : null}
            {descrepencyImageView && (
                <PoImagePreview
                    descrepencyExists
                    closePoImagePreview={() => {
                        try {
                        dispatch(setDescrepencyImageViewState(false));
                        dispatch(resetPoImagePreview());
                        dispatch(
                            showHideSendReportAction({ sendReportModal: false })
                        );
                        } catch (error) {
                           logErrorToConsole(error);
                         }
                    }}
                    onCloseDescrepencyFile={(e) => {
                        dispatch(setDescrepencyImageViewState(false));
                        dispatch(resetPoImagePreview());
                        dispatch(
                            showHideSendReportAction({ sendReportModal: true })
                        );
                        e.stopPropagation();
                    }}
                />
            )}
            {viewReportOpen && (
                <ViewReport
                    onCloseViewReportHandler={onCloseViewReportHandler}
                    onCloseViewReportIconHandler={onCloseViewReportIconHandler}
                />
            )}
            {showSaveAsTemplate && myCaseRef && (
                <>
                    <ModalDialog
                        marginTop={'30%'}
                        overflowX={'hidden'}
                        maxWidth={'841px'}
                        handleClose={toggleViewTemplate}
                        zIndex={dialogZindex}
                        paddingBottom={'110px'}
                        padding={'16px 3px 16px 16px'}
                        afterSubmitTemplate={false}
                    >
                        {orderBasicDetails?.currentOrderType === 'ZOR' ? (
                            <CreateEquityTemplate
                                handleClose={toggleViewTemplate}
                                orderData={myCaseRef}
                                origin={'calendar'}
                                isFromOrderHistory={isOrderHistory}
                                onOpen={() => {
                                    try {
                                    setDialogZindex(2000);
                                    //onSelectOpen();
                                    } catch (error) {
                                         logErrorToConsole(error);
                                     }
                                }}
                                onClose={() => {
                                    try {
                                    setDialogZindex(10000);
                                    //onSelectClose();
                                    } catch (error) {
                                         logErrorToConsole(error);
                                     }
                                }}
                                orderPageMobilePadding={'11px'}
                                footerButtonSize={'15px'}
                                footerButtonMargin={'0px'}
                            />
                        ) : (
                            <CreateTemplate
                                createStandardTemplate={true}
                                handleClose={toggleViewTemplate}
                                orderData={myCaseRef}
                                origin={'calendar'}
                                isFromOrderHistory={isOrderHistory}
                                onOpen={() => {
                                    try {
                                    setDialogZindex(2000);
                                    //onSelectOpen();
                                     } catch (error) {
                                         logErrorToConsole(error);
                                     }
                                }}
                                onClose={() => {
                                    try {
                                    setDialogZindex(10000);
                                    //onSelectClose();
                                    } catch (error) {
                                         logErrorToConsole(error);
                                     }
                                }}
                                orderPageMobilePadding={'11px'}
                                footerButtonSize={'15px'}
                                footerButtonMargin={'0px'}
                                templateMandatoryFields={checkTemplateReviewUserRoleChanges(
                                    employeeRole,
                                    SURGERY_TEMPLATE_MANDATORY_FIELDS
                                )}
                            />
                        )}
                    </ModalDialog>
                </>
            )}
            {requestInvoiceState &&
                !isRequestInvoiceOrderListPage &&
                !isRequestInvoiceSearchListPage && (
                    <RequestInvoice
                        onCloseRequestInvoiceHandler={
                            onCloseRequestInvoiceHandler
                        }
                    />
                )}
            <SetItemModal
                isEquity={
                    orderBasicDetails?.currentOrderType == 'ZOR' ? true : false
                }
                handleClose={(isSet) => {
                    isSet ? showSetDetails(false) : showItemDetails(false);
                    setProductStack([]);
                    dispatch(
                        showHideSummaryModal({
                            orderSummaryModal: true,
                        })
                    );
                }}
                handleSetItemClick={handleSetItemClick}
                selectedItem={selectedItem}
                previousSelectedItem={previousSelectedItem}
                setDetails={setDetails}
                itemDetails={itemDetails}
                showSetDetails={showSetDetails}
                showItemDetails={showItemDetails}
                setPreviousItem={setPreviousItem}
                showBackText={true}
                backText={`${t('common.backToText')} ${myCaseRefId}`}
                previousCfn={productStack[productStack.length - 2]}
                onBackClick={(item) => handleSetItemClick(item, true)}
                isOnlyPlusButton={false}
                zIndex={'2000'}
                marginTop={'30%'}
                isOrderDetail
            />
        </>
    );
};

export default OrderDetails;
